<template>
  <q-list padding>
    <template v-if="!loading">
      <q-item>

        <q-item-section>
          {{ organization?.name }}
        </q-item-section>
      </q-item>

      <q-item clickable v-ripple :to="`/organizations/${organizationId}/users`"
              v-if="organization?.yourPermission === 'ADMINISTRATOR'">
        <q-item-section avatar>
          <q-icon name="people"/>
        </q-item-section>

        <q-item-section>
          Участники
        </q-item-section>
      </q-item>

      <q-item :to="`/organizations/${organizationId}/settings`"
                        v-if="organization?.yourPermission === 'ADMINISTRATOR'">
          <q-item-section avatar>
              <q-icon name="settings"/>
          </q-item-section>

          <q-item-section>
              Настройки
          </q-item-section>
      </q-item>
    </template>
    <template v-else>
      <q-item style="max-width: 300px">
        <q-item-section avatar>
          <q-skeleton type="QAvatar"/>
        </q-item-section>

        <q-item-section>
          <q-item-label>
            <q-skeleton type="text"/>
          </q-item-label>
          <q-item-label caption>
            <q-skeleton type="text" width="65%"/>
          </q-item-label>
        </q-item-section>
      </q-item>

      <q-item style="max-width: 300px">
        <q-item-section>
          <q-item-label>
            <q-skeleton type="text"/>
          </q-item-label>
          <q-item-label caption>
            <q-skeleton type="text" width="90%"/>
          </q-item-label>
        </q-item-section>
      </q-item>

      <q-item style="max-width: 300px">
        <q-item-section>
          <q-item-label>
            <q-skeleton type="text" width="35%"/>
          </q-item-label>
          <q-item-label caption>
            <q-skeleton type="text"/>
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </q-list>
</template>

<script setup lang="ts">
import {useProjectStore} from "../../store/project";
import {storeToRefs} from "pinia";
import {computed, watch} from "vue";
import {useRoute} from "vue-router";
import {useTaskTypes} from "../../composables/task";
import Avatar from "../Avatar.vue";
import {useRouteParams} from "@vueuse/router";
import {useOrganization, useOrganizations} from "../../composables/organization";

const route = useRoute()

const organizationId = useRouteParams('organizationId', undefined, {transform: Number})



const {data: organization, isFetching: loading} = useOrganization(organizationId)

</script>

<style scoped>

</style>